import { Language, PaymentFormType } from '../../api';
import { OrderPageIntent } from '../OrderPageIntent';

export enum StepId {
  DETAILS = 'DETAILS',
  PROJECT_SELECTION = 'PROJECT_SELECTION',
  VOUCHER_SUMMARY = 'VOUCHER_SUMMARY',
  DATE_AND_TIME = 'DATE_AND_TIME',
  PERSONAL_DETAILS = 'PERSONAL_DETAILS',
  GIFT_CARD_TYPE = 'GIFT_CARD_TYPE',
  GIFT_CARD_AMOUNT = 'GIFT_CARD_AMOUNT',
  GIFT_CARD_PERSONAL_DETAILS = 'GIFT_CARD_PERSONAL_DETAILS',
  DISCLAIMERS = 'DISCLAIMERS',
  PAYMENT = 'PAYMENT',
  REDEMPTION_SUMMARY = 'REDEMPTION_SUMMARY',
  PASS_SUMMARY = 'PASS_SUMMARY',
  PASS_SCHEDULE_SELECTIONS = 'PASS_SCHEDULE_SELECTIONS',
  PASS_DATED_SESSION_SELECTIONS = 'PASS_DATED_SESSION_SELECTIONS',
}

export enum SaveStrategy {
  ORDER = 'ORDER',
  VOUCHER = 'VOUCHER',
  PASS = 'PASS',
}

export type StepConditionContext = {
  orderPage: any;
  language: Language;
  isStandaloneGiftCard: boolean;
};

export type StepConfig = {
  id: StepId;
  stepperLabel: string;
  condition?: (ctx: StepConditionContext) => boolean;
};

export type IntentConfig = {
  intent: OrderPageIntent;
  steps: StepConfig[];
  requiresDateSelection: boolean;
  hasSessionTimeout: boolean;
  canSwitchToGiftCard: boolean;
  saveStrategy: SaveStrategy;
  paymentFormType: PaymentFormType | null;
};
